export const environment = {
    production: false,
    apiUrl: 'https://edge-api-v2-staging.nside.io'
};
  